const envVars = import.meta.env;

export const isDev = () => envVars.VITE_ENV === "DEV";

export function getEmailState(state: string): string {
  switch (state) {
    case "UNVERIFIED":
      return "Non vérifié";

    default:
      throw new Error("Invalid email state");
  }
}

export function onEnter(e: React.KeyboardEvent, callback: () => void) {
  if (e.key === "Enter") {
    callback();
  }
}
